export default "__VITE_PUBLIC_ASSET__4dcca6a2__"